// Constants
import {
    INITIALIZE_PARTICIPATING_UNIVERSITY_DETAILS,
    INITIALIZE_STUDENT_DETAILS,
    LOADING_INDIVIDUAL_STUDENT_DETAILS,
    LOADING_STUDENTS,
} from "@/store/actions/studentDetailsActions";
import { updateParticipatingUniversitiesInStudent } from "@/utils/students";

const initialState = {
    data: [],
    oldData: [],
    loadingList: true,
    loading: true,
    count: 0,
};

const studentDetailsReducer = (state = initialState, action) => {
    if (action.type === INITIALIZE_STUDENT_DETAILS) {
        return { ...state, data: action.payload.data, oldData: action.payload.oldData, loadingList: false };
    } else if (action.type === LOADING_STUDENTS) {
        return { ...state, loadingList: action.payload, count: state.count + 1 };
    } else if (action.type === LOADING_INDIVIDUAL_STUDENT_DETAILS) {
        return { ...state, loading: action.payload };
    } else if (action.type === INITIALIZE_PARTICIPATING_UNIVERSITY_DETAILS) {
        return {
            ...state,
            data: updateParticipatingUniversitiesInStudent(
                state.data,
                action.payload.registrantCode,
                action.payload.participatingUniversities
            ),
        };
    } else {
        return state;
    }
};

export default studentDetailsReducer;
